import styled from 'styled-components';
import bg from '../../assets/images/login/bg.png';

export const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(${bg}) no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  font-family: 'Lato', sans-serif;
  flex-direction: column;
  .login-text {
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    font-weight: bolder;
    font-size: 18px;
    background-color: #ffc300;
    width: 12rem;
    height: 3rem;
    border-radius: 50px;
    text-align: center;
    padding-top: 0.8rem;
    color: #00318a;
  }
  @media (width: 1024px), (width: 1366px), (width:1180px) {
    .second-img {
      width: 110% !important;
    }
  }
  .form-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 2rem 2.25rem;
    border-radius: 10px;

    &__title {
      margin-block: 1rem;
      font-size: 1.5rem;
      font-weight: 600;
      color: #120e31;
    }

    &__form-control {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: start;

      & label {
        margin-left: 7px;
        color: #5a595c;
      }

      & input {
        width: 400px;
        outline: none;
        border-radius: 50px;
        margin-top: 5px;
        padding: 10px 15px;
        border: none;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.38);
        color: #00318a;
        &::placeholder {
          color: #00318a;
        }
      }
    }

    &__btn {
      margin-top: 2rem;
      border: none;
      background: none;
      align-items: center;
    }
  }

  .gsk-logo {
    position: absolute;
    width: 35px;
    bottom: 56px;
    left: 56px;
  }
`;
